<template>
  <div id="app">
  <b-modal ref="adblock-modal" hide-footer hide-header  class="p-0" centered :no-close-on-backdrop="true">
      <div class="d-block modal-head text-center">
        <h3>Ad-Blocker Detected</h3>
      </div>
      <div class="modal-desc">
      <p class="text-justify ">
      Please Disable Adblocker and refresh the page for better experience
      </p>
      </div>
    </b-modal>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      currentPagePath:'/',
      currentPageLink:''
    }
  },
  updated(){
    this.currentPagePath=this.$router.currentRoute.path;
    
  },
  
}
</script>

<style>
/* Font Families */
@font-face{
  font-family: "Avenir85";
  src: url("./assets/fonts/AEH.ttf") format("truetype");
  font-display: swap;
}

/* Class CSS */
.scrollbar {
  margin-left: 30px;
  float: left;
  height: 300px;
  width: 65px;
  background: #F5F5F5;
  overflow-y: scroll;
  margin-bottom: 25px;
}
/* Colors */
:root{
--mainBlueColor: #1F3D71;
--mainGreyColor:#cdcfd0;
--mainRedColor:#E8242B;
--mainWhiteColor:white;
--mainlightWhiteColor:#ffffff;
--mainlightBlueColor:#007bff;
--mainYellowColor:#fcb13f;
}

/* ID CSS */
#app {
  font-family: 'Avenir85';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* Testing */
  width: 100%;
  height: 100%;
  overflow-y: scroll;          /* Enable for full page smooth scroll*/
  /*overflow-y: hidden;*/      /* Disable for full page smooth scroll*/
  overflow-x: hidden;
  scroll-behavior: smooth;
  scroll-snap-points-y: repeat(100%);
  scroll-snap-type: y mandatory;
}
#app::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  border-radius: 10px;
  background-color: #F5F5F5;
}
#app::-webkit-scrollbar {
  width: 8px;
  background-color: #F5F5F5;
}
#app::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
  background-color: #A3A3A3;
}

/* Tag CSS */
/*Enable for smooth scroll*/
body {         
  height: 100vh;
  line-height: 1.6;
  overflow: hidden;
}
html {
  scroll-behavior: smooth;
}
section {
  min-height: 100vh;
  display: flex !important;
  flex-direction: column;
 /* align-items: center; */
  justify-content: center;
  scroll-snap-align: start;
  scroll-snap-stop: always;
}
section:last-of-type {
  min-height: 88vh;
  align-items: normal;
  justify-content: flex-end;
 /* background: url("./assets/background/footer_bg.png");*/
  background-position: center 30%;
  background-repeat: repeat;
  background-size: cover;
  -o-background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover;
}
section#media, section#unsecured-app, section#secured-app {
  border-top: 2px solid white;
}

.modal-head{
  background-color:var(--mainBlueColor);
  color:var(--mainWhiteColor);
}

@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  section:last-of-type {
    min-height: auto;
  }
}
/* Mobile Screen */
@media (min-width: 481px) and (max-width: 767px) {
  section {
    min-height: auto;
    display: block !important;
  }
  section:last-of-type {
    min-height: auto;
  }
  body {         
    height: auto;
    line-height: 1.6;
    overflow: auto;
  }
  #app {
    overflow-y: hidden;
  }
}
@media (max-width: 480px) {
  section {
    min-height: 100vh;
    display: block !important;
  }
  section:last-of-type {
    min-height: auto;
  }
  body {         
    height: auto;
    line-height: 1.6;
    overflow: auto;
  }
  #app {
    overflow-y: hidden;
  }
}
</style>
